// en/channel.js
export const channel = {
  header: {
    title: "Canais de reserva",
    subtitle: "Sincronize ou gerencie Booking.com, Expedia, Airbnb e muitos outros.",
  },

  establishedConnections: "Conexões estabelecidas",

  common: {
    loading: "Carregando...",
    configure: "Configurar",
    close: "Fechar",
    comingSoon: "Em breve",
  },

  alerts: {
    bullets: {
      choosePlan: "Escolha um plano e ative seu Channel Manager.",
      completeProperty: "Conclua a configuração da sua propriedade no painel.",
    },
    title: "Ação necessária",
    planRequired:
      "Você precisa ter um plano ativo para vincular sua propriedade a uma OTA.",
    missingPropertyChannel:
      "Para conectar-se a uma OTA, você precisa primeiro concluir a configuração da sua propriedade no Channel Manager.",
  },

  modal: {
    channelHeader: "Conexão de canal com {channel}",
  },

  web: {
    cardTitle: "Reservas diretas pela web",
    // NEW: description for the OTA-style card
    cardDescription:
      "Receba reservas diretas do seu site sem comissões de OTA.",
    // NEW: button texts for card and table
    manageCta: "Gerenciar",
    configureCta: "Configurar",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Link de reserva direta",

    linkShareMessage: "Olá 👋 Você pode reservar usando este link:\n\n{link}",
    modalTitle: "Reservas diretas pela web",
    description:
      "Ative ou desative as opções disponíveis para reserva direta no seu site. Os hóspedes poderão reservar diretamente, sem intermediários.",
    toggleAllDesktop: "Ativar/Desativar todas as reservas pela web",
    toggleAllMobile: "Ativar/Desativar",
    table: {
      name: "Nome",
      available: "Disponível para reserva pela web",
    },
    capacity: "Capacidade",
    people: "pessoas",
    empty: "Nenhum item encontrado",

    // Link section
    linkTitle: "Seu link de reserva direta",
    linkHelp: "Compartilhe este link para que seus hóspedes possam reservar diretamente",
    linkCopyTooltip: "Copiar link",
    linkShareWhatsappTooltip: "Compartilhar no WhatsApp",
  },

  plan: {
    title: "Ative seu plano para conectar",
    subtitle:
      "Escolha o plano que atende às suas necessidades e ative a conexão com Booking, Airbnb, Expedia e outros.",
    hint: "Assim que você assinar, volte aqui; vamos desbloquear todos os canais aos quais você pode se conectar.",
    cta: "Fazer upgrade do plano",
  },

  toasts: {
    paymentTypeUpdated: "Forma de pagamento atualizada com sucesso",
    linkCopiedTitle: "Copiado!",
    linkCopiedBody: "Link copiado com sucesso",
    linkCopyErrorTitle: "Erro",
    linkCopyErrorBody: "Ocorreu um erro ao copiar o link",
    save: "Erro ao salvar a configuração",
    updateWebReservation: "Erro ao atualizar a reserva pela web",
    saved: "Configuração salva com sucesso",
    updateWebReservationsGlobal:
      "Estado global das reservas diretas atualizado com sucesso",
  },

  errors: {
    loadData: "Erro ao carregar os dados. Tente novamente.",
    generateToken: "Erro ao gerar o token",
    connectChannel: "Erro ao conectar-se ao canal. Tente novamente.",
    updatePaymentType: "Erro ao atualizar a forma de pagamento",
    save: "Erro ao salvar a configuração",
    updateWebReservation: "Erro ao atualizar a reserva pela web",
  },

  tabs: {
    reservations: "Status da reserva",
    payments: "Preços e Pagamentos",
    share: "Compartilhar",
  },

  payments: {
    title: "Como você gostaria de receber os pagamentos das reservas diretas?",
    onArrival: {
      label: "Pagar na propriedade",
      desc: "Os hóspedes pagarão diretamente na chegada",
    },
    online: {
      label: "Pré-pagamento online",
      desc: "Os hóspedes pagarão ao fazer a reserva",
    },
  },

  discounts: {
    sectionTitle: "Configurar desconto para reservas diretas",
    toggle: "Aplicar desconto às reservas diretas",
    typeTitle: "Tipo de desconto:",
    percentage: {
      label: "Desconto percentual",
      desc: "Aplicar um desconto percentual",
    },
    fixed: {
      label: "Desconto de valor fixo",
      desc: "Aplicar um desconto de valor fixo",
    },
    valueTitle: "Valor do desconto:",
    placeholderPercentage: "Ex.: 10",
    placeholderFixed: "Ex.: 50.00",
    helpPercentage:
      "Insira um valor entre 1 e 100 para a porcentagem de desconto",
    helpFixed: "Insira o valor fixo em euros a ser descontado do total",
    previewTitle: "Prévia:",
    previewPercentage: "Um desconto de {value}% será aplicado às reservas diretas",
    previewFixed: "Um desconto de €{value} será aplicado às reservas diretas",
  },

  buttons: {
    saveChanges: "Salvar alterações",
  },
};
